/** Steep roof system display labels — aligned with EstimatorPage STEEP_SYSTEMS. */
export const STEEP_SYSTEM_LABELS: Record<string, string> = {
    SHINGLE: 'Shingle',
    TILE: 'Tile',
    METAL: 'Metal',
};

/** Flat roof system display labels — aligned with EstimatorPage FLAT_SYSTEMS. */
export const FLAT_SYSTEM_LABELS: Record<string, string> = {
    BUILDUP: 'GAF Built-Up',
    POLYGLASS: 'Polyglass Built-Up Self Adhered',
    TPO: 'GAF TPO',
    'WATERPROOF-SB': 'Waterproofing Surface Seal SB',
    TREMCO: 'Tremco Waterproofing',
    HYDROSTOP: 'Liquid Hydrostop',
    'NONE-FLAT': '',
};

export function steepSystemLabel(steepSystemId: string, steepLabel?: string | null): string {
    return steepLabel || STEEP_SYSTEM_LABELS[steepSystemId] || steepSystemId;
}

export function flatSystemLabel(flatSystemId: string, flatLabel?: string | null): string {
    return flatLabel || FLAT_SYSTEM_LABELS[flatSystemId] || flatSystemId;
}

/** Mirror backend roof_system_display() for preview/PDF parity. */
export function roofSystemDisplay(params: {
    showSteep: boolean;
    showFlat: boolean;
    steepSystemId: string;
    flatSystemId: string;
    steepLabel?: string | null;
    flatLabel?: string | null;
}): string {
    const steep = steepSystemLabel(params.steepSystemId, params.steepLabel);
    const flat = flatSystemLabel(params.flatSystemId, params.flatLabel);
    const parts: string[] = [];
    if (params.showSteep) parts.push(steep);
    if (params.showFlat && flat) parts.push(flat);
    return parts.length ? parts.join(' & ') : '—';
}
